import ServicesFeaturesMain from "../components/services-features-main"
import ServicesHero from "../components/services-hero";

function Services() {
  return (
    <>
      <div>
        <ServicesHero />
        <ServicesFeaturesMain />
      </div>
    </>
  );
}

export default Services;
